import React from "react";
import PageHeader from "../../../components/Common/PageHeader";

function GridHeader() {
  return <PageHeader title="Conhecimento de Transporte - Anular Validação" />;
}

export default GridHeader;
